module.exports = __webpack_public_path__ + "img/Aramex-logo-English.2955c50f.webp";